import React from "react";

interface OwnProps {
    editProfile?: boolean;
}

export default (props: OwnProps) => {
    const { editProfile } = props;
    const fill = editProfile ? "#BDBCBC" : "#0069B4";
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.2037 2.25025L18.7137 2.76125L21.7737 5.82125L22.2847 6.33125L22.7947 5.82125L23.8157 4.80225L24.3247 4.29025C24.6057 4.01125 24.6067 3.55225 24.3247 3.27025L21.2657 0.21125C20.9837 -0.0707503 20.5247 -0.0697497 20.2447 0.21025L19.7337 0.72025L18.7147 1.74125L18.2037 2.25025Z"
                fill={fill}
            />
            <path
                d="M16.9711 3.48372L4.13153 16.3232L8.2122 20.4039L21.0517 7.5644L16.9711 3.48372Z"
                fill={fill}
            />
            <path
                d="M2.89566 17.5582L0.53166 23.7102C0.43066 23.9722 0.561659 24.1032 0.823659 24.0022L6.97566 21.6392L2.89566 17.5582Z"
                fill={fill}
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/components/CustomPenIcon/CustomPenIcon.tsx